var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TwitterPicker } from 'react-color';

import { COLORS } from "../../utils/colors";

class ColorPicker extends Component {
  constructor(props) {
    super(props);
    this.state = { active: false };
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onColorChange = this.onColorChange.bind(this);
  }

  onColorChange({ hex }) {
    const { onChange } = this.props;
    onChange(hex);
  }

  onButtonClick() {
    this.setState((oldState) => ({ active: !oldState.active }));
  }

  onBlur() {
    this.setState({ active: false });
  }

  render() {
    const { active } = this.state;
    const { value, defaultValue } = this.props;
    return /*#__PURE__*/(
      _jsx("div", { className: "ColorPicker" }, void 0, /*#__PURE__*/
      _jsx("div", {
        className: "ColorPicker__button",
        style: { backgroundColor: value || defaultValue },
        onClick: this.props.disabled ? () => {} : this.onButtonClick }
      ),
      active && /*#__PURE__*/
      _jsx("div", { className: "ColorPicker__popover" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "ColorPicker__cover", onClick: this.onBlur }), /*#__PURE__*/
      _jsx(TwitterPicker, {
        color: value || defaultValue,
        colors: COLORS,
        onChangeComplete: this.onColorChange }
      )
      )

      ));

  }
}

ColorPicker.defaultProps = {
  value: '',
  defaultValue: '',
  disabled: false
};








export default ColorPicker;